import { render, staticRenderFns } from "./SideBar.vue?vue&type=template&id=5859261c&"
import script from "./SideBar.vue?vue&type=script&lang=ts&"
export * from "./SideBar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports